"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement("path", {
  d: "M17.79 3.77a12.54 12.54 0 0 0-13-.86.24.24 0 0 1-.29-.05L1.94.27a.53.53 0 0 0-.55-.11.51.51 0 0 0-.31.46v6.7a.51.51 0 0 0 .5.5h6.7a.5.5 0 0 0 .46-.31.49.49 0 0 0-.11-.51L6.78 5.11a.22.22 0 0 1-.06-.22.23.23 0 0 1 .15-.18 9.94 9.94 0 0 1 9.46 1.1 9.74 9.74 0 0 1 .1 15.8 1.25 1.25 0 0 0-.27 1.75 1.22 1.22 0 0 0 1 .51 1.25 1.25 0 0 0 .73-.24 12.25 12.25 0 0 0-.11-19.86Z"
}), 'Undo');

exports.default = _default;